"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immer_1 = require("immer");
const getTeacherFeedbackGivenEvent_1 = require("../helpers/getEvent/getTeacherFeedbackGivenEvent");
const feedbackInteraction_1 = require("../helpers/getInteraction/feedbackInteraction");
const getInteractionKey_1 = require("../helpers/getInteraction/getInteractionKey");
const getState_1 = require("../helpers/getState");
const getStateInteraction_1 = require("../helpers/getStateInteraction");
const entity_1 = require("../type/entity");
function getFeedbackInteractionParam(command, user, rootContentId, submissionId) {
    const { cardQuestionId, timeStamp, creatorId: teacherId, feedbackText, isAnonymous = false, actorType } = command;
    const { userId: studentId, companyId } = user;
    return {
        cardQuestionId,
        companyId,
        actorType,
        feedbackText,
        rootContentId,
        studentId,
        submissionId,
        teacherId,
        timeStamp,
        isAnonymous
    };
}
function applyTeacherFeedbackCommand(command, user, states, stateInteractions) {
    const { cardQuestionId, creatorId: teacherId, feedbackText, timeStamp, rootContentId, actorType } = command;
    const events = [];
    const cardQuestionState = getState_1.getStateByContentIdUserId(states, cardQuestionId, user.userId);
    const submissionId = cardQuestionState.submissions[0]._id;
    const updatedStateInteractions = immer_1.produce(stateInteractions, draftStateInteractions => {
        const interactionKeyForLearner = getInteractionKey_1.getInteractionKeyForLearner(cardQuestionId, entity_1.InteractionType.Feedback, submissionId, teacherId);
        let stateInteraction = getStateInteraction_1.getStateInteractionByInteractionKeyForLearner(draftStateInteractions, interactionKeyForLearner);
        if (!stateInteraction) {
            const feedbackInteractionParam = getFeedbackInteractionParam(command, user, rootContentId, submissionId);
            stateInteraction = feedbackInteraction_1.getFeedbackInteraction(feedbackInteractionParam);
            draftStateInteractions.push(stateInteraction);
        }
        else {
            stateInteraction.actorType = actorType;
            stateInteraction.deleted = false;
            stateInteraction.feedbackText = feedbackText;
            stateInteraction.updatedAt = timeStamp;
        }
        const teacherFeedbackGiven = getTeacherFeedbackGivenEvent_1.getTeacherFeedbackGivenEvent(command, user, rootContentId, entity_1.ContentType.CARD_QUESTION, submissionId);
        events.push(teacherFeedbackGiven);
    });
    return { states: [], events, stateInteractions: updatedStateInteractions, enrolments: [] };
}
exports.applyTeacherFeedbackCommand = applyTeacherFeedbackCommand;
//# sourceMappingURL=applyTeacherFeedbackCommand.js.map